module.exports = {
  searchBar: {
    placeholder: 'Brand, model, year ...',
  },
};
